// import { NavLink } from "react-router-dom";

import './RST02.css';

import mapa from '../../../images/movilidad/mapa-restaurante-ruta02.jpg';

function Ruta() {
  return (
    <div className='full'>
      <img src={mapa} width="" height="" alt='' className='full cnt map' />
    </div>
  );
}

export default Ruta;
